import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "9f7353b6-9408-4045-95a5-ee23c6e534ad"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter9f7353b69408404595a5Ee23c6e534ad(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter9f7353b69408404595a5Ee23c6e534ad footer`}>
      {props["links"] || <Navigation className="Links3dee470f9ae645e989d793b03db0cddc" parentTag={buildClassName("Links3dee470f9ae645e989d793b03db0cddc", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoDded861fD92d4c8d866e92472899a155" parentTag={buildClassName("LogoDded861fD92d4c8d866e92472899a155", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightA2778b63283e4a0aAae0C838520ae63f" parentTag={buildClassName("CopyrightA2778b63283e4a0aAae0C838520ae63f", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow4fa46b850ee146a5A566Ad7e64c81fb5" parentTag={buildClassName("Groupflow4fa46b850ee146a5A566Ad7e64c81fb5", parentTag)} {...props} />}
    </footer>
  );
}

// id: "dded861f-d92d-4c8d-866e-92472899a155"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "9f7353b6-9408-4045-95a5-ee23c6e534ad"
export function LogoDded861fD92d4c8d866e92472899a155(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoDded861fD92d4c8d866e92472899a155" parentTag={buildClassName("LogoDded861fD92d4c8d866e92472899a155", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "a2778b63-283e-4a0a-aae0-c838520ae63f"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "9f7353b6-9408-4045-95a5-ee23c6e534ad"
export function CopyrightA2778b63283e4a0aAae0C838520ae63f(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightA2778b63283e4a0aAae0C838520ae63f" parentTag={buildClassName("CopyrightA2778b63283e4a0aAae0C838520ae63f", parentTag)} {...props} />
  );
}

// id: "3dee470f-9ae6-45e9-89d7-93b03db0cddc"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "9f7353b6-9408-4045-95a5-ee23c6e534ad"
export function Links3dee470f9ae645e989d793b03db0cddc(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links3dee470f9ae645e989d793b03db0cddc" parentTag={buildClassName("Links3dee470f9ae645e989d793b03db0cddc", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "4fa46b85-0ee1-46a5-a566-ad7e64c81fb5"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "9f7353b6-9408-4045-95a5-ee23c6e534ad"
export function Groupflow4fa46b850ee146a5A566Ad7e64c81fb5(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow4fa46b850ee146a5A566Ad7e64c81fb5" parentTag={buildClassName("Groupflow4fa46b850ee146a5A566Ad7e64c81fb5", parentTag)} {...props} />
  );
}

// id: "41256e78-d2d7-4e14-96c0-e33f0ac596ca"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "dded861f-d92d-4c8d-866e-92472899a155"
export const LogoType41256e78D2d74e1496c0E33f0ac596ca = "FOOTER";

// id: "eaa0d0d1-fe38-4546-a220-7c19d34be186"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "3dee470f-9ae6-45e9-89d7-93b03db0cddc"
export const NavMenuSlugEaa0d0d1Fe384546A2207c19d34be186 = "footer-nav";

// id: "0efc3c3a-ef3e-4b78-ad89-c6ed9ca35e19"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "dded861f-d92d-4c8d-866e-92472899a155"
export const ContentSlug0efc3c3aEf3e4b78Ad89C6ed9ca35e19 = "footer-logo";

const Components = {
  DefaultFooter9f7353b69408404595a5Ee23c6e534ad,
  LogoDded861fD92d4c8d866e92472899a155,
  CopyrightA2778b63283e4a0aAae0C838520ae63f,
  Links3dee470f9ae645e989d793b03db0cddc,
  Groupflow4fa46b850ee146a5A566Ad7e64c81fb5,
  LogoType41256e78D2d74e1496c0E33f0ac596ca,
  NavMenuSlugEaa0d0d1Fe384546A2207c19d34be186,
  ContentSlug0efc3c3aEf3e4b78Ad89C6ed9ca35e19
}

export default Components;